import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';

import {IonicModule} from '@ionic/angular';

import {SupplierPageRoutingModule} from './supplier-routing.module';

import {SupplierPage} from './supplier.page';
import {SupplierSearchModule} from './supplier-search/supplier-search.module';
import {JwPaginationModule} from 'jw-angular-pagination';



@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SupplierPageRoutingModule,
    SupplierSearchModule,
    JwPaginationModule
  ],
  declarations: [SupplierPage]
})
export class SupplierPageModule {
}
